import { useSessionAuth } from '@/context/Auth';
import { uploadImage } from '@/infrastructure/api/images';
import { UploadedImage } from '@/infrastructure/domain/images';
import { UseMutationResult, useMutation } from '@tanstack/react-query';

export const useUploadImage = (): UseMutationResult<
  UploadedImage,
  Error,
  FormData,
  unknown
> | null => {
  const { token } = useSessionAuth();

  return useMutation({
    mutationFn: (payload: FormData) => uploadImage(token!, payload),
  });
};
